export class TimelessAccountRequestModel {
    id = null;
    name;
    volumeGb;
    authorizedAccounts = [];
}
export class TimelessAccountModel {
    id;
    ownerAccountId;
    name;
    volumeGb;
    logType;
    createdAt;
    actualUsage;
    dailyUsage;
    authorizedAccounts;
    suspended;
}
export class DetailedTimelessAccountsSummaryModel {
    sharingObjectsAccounts;
    maxAllowed;
    totalVolumeGb;
    timelessIndices;
}
export class TimelessDeleteDataModel {
    timeFrameFrom; // unix
    timeFrameTo; // unix
    optimizerIds;
}
//# sourceMappingURL=timeless-account.js.map